import { PipeTransform, Pipe } from '@angular/core';


@Pipe({
    name: "modifyHeader",
    standalone: false
})
export class ModifyHeader implements PipeTransform {
  transform(value: string): string {
    return value;
  }
}
